/* eslint-disable */
// Single Product
// Show Inkijkexemplaar button if PDF exists
//
import $ from 'jquery';

export class Show_PDF_Button {

  constructor() {

    // is the Shop element even here?
    if (!$('.book').length > 0) return;

    $(function () {
      if (!$('.webshop-product-preview-modal ')[0]) {
        $('.preview-button').remove();
      }
    });
  }
}

export class Show_Webshop_Box {

  constructor() {

    // is the Shop element even here?
    if (!$('.book').length > 0) return;

    const testVar = "<?=get_field('webshop_box_content','option'); ?>";

    $(function () {
      if (testVar.length > 0) {
        $('.sidebar-feature').remove();
      } else {
        console.log('is filled');
      }
    });
  }
}

export class Remove_Div {

  constructor() {

    // is the Shop element even here?
    if ($('.book').length > 0) return;

    $(function () {
      $('.imageStop').remove();
    });
  }
}

export class RemoveDonation {
  constructor() {
    $(function () {
      //$(".product-card-title").filter(':contains("Donatie Stichting")').closest(".product-card").hide();
    });
  }
}

export class DonationURL {
  constructor() {

    $(function () {
      ["1", "2", "5", "10", "15"].forEach((x) => {
        const donation = $(`.amount_${x}`).attr("data-product_id");
        const $link = $(`#${donation}`).find("a").clone().text("");
        if (!$link || $link.length <= 0) return;
        $(`.amount_${x}`)
          .removeAttr("href")
          .removeClass("add_to_cart_button")
          .wrap($link)
          .addClass("active");
      });
    });
  }
}
